import isEmpty from 'lodash-es/isEmpty'

export function getCalendarRailBuildingOption(building) {
  return building ? { label: building.name, value: building.id } : null
}

export function isCalendarRailBuildingListEmpty({ data }) {
  return isEmpty(data.items)
}

export function toCalendarRailBuilding({ label, value }) {
  return { id: value, name: label }
}
